import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";
import { doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_ADD_TASK } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_TASK_GARMIN_DEVICE_CREATE = "REQUEST_TASK_GARMIN_DEVICE_CREATE";
export const doREQUEST_TASK_GARMIN_DEVICE_CREATE = createDoRequestAction(
  REQUEST_TASK_GARMIN_DEVICE_CREATE,
);

export const requestTaskGarminDeviceCreateActionCreators = {
  doREQUEST_TASK_GARMIN_DEVICE_CREATE,
};

export function* requestTaskGarminDeviceCreate({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestTaskGarminDevice");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        garminDevice: v.object({
          type: v.string().exist(),
          accelerometerEnable: v.boolean().optional(),
          zeroCrossingEnable: v.boolean().optional(),
          stepsEnable: v.boolean().optional(),
          stressEnable: v.boolean().optional(),
          heartRateEnable: v.boolean().optional(),
          pulseOxEnable: v.boolean().optional(),
          respirationEnable: v.boolean().optional(),
          bbiEnable: v.boolean().optional(),
          enhancedBbiEnable: v.boolean().optional(),
          temperatureEnable: v.boolean().optional(),
          actigraphyEnable: v.boolean().optional(),
          zeroCrossingSampleRate: v.number().min(30).max(3600).optional(),
          stressSampleRate: v.number().min(1).max(3600).optional(),
          heartRateSampleRate: v.number().min(1).max(3600).optional(),
          pulseOxSampleRate: v.number().min(1).max(3600).optional(),
          respirationSampleRate: v.number().min(1).max(3600).optional(),
          actigraphySampleRate: v.number().valid(60, 30, 15, 10).optional(),
          actigraphyZeroCrossingThreshold: v.number().min(1).max(100).optional(),
          actigraphyEnergyThreshold: v.number().min(1).max(100).optional(),
          temperatureSampleRate: v.number().min(1).max(3600).optional(),
        }),
        methodId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_GARMIN_DEVICE_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { garminDevice, methodId } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/task-garmin-device-create`,
    accessToken,
    data: {
      garminDevice,
      methodId,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_GARMIN_DEVICE_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/task-garmin-device-create",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doMETHOD_ADD_TASK(result.payload));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_GARMIN_DEVICE_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* taskGarminDeviceCreateSaga() {
  yield takeEvery(REQUEST_TASK_GARMIN_DEVICE_CREATE, requestTaskGarminDeviceCreate);
}
